import Head from 'next/head'

import { CompleteSettingPage } from '~/ui/screens/settings/settings'
import { withAuth } from '~/utils/hoc'

function DashboardPage() {
  return (
    <>
      <Head>
        <title>Settings</title>
        <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
      </Head>
      <CompleteSettingPage />
    </>
  )
}

export default withAuth(DashboardPage)
